export enum CURSOR {
    DEFAULT = 'default',
    GRABBING = 'grabbing',
    POINTER = 'pointer'
}